import React from 'react';
import { KatBox } from '@amzn/katal-react';
import HelpHeader from './HelpHeader';

import './App.scss';

export class ScratchpadHeader extends React.Component<{region: string}> {

    constructor(props: Readonly<{ region: string; }>) {
        super(props);
    }

    render() {
        return (
            <>
            <div id="Scratchpad_header_div">
                <KatBox variant="white-junglemist" className="Scratchpad_header">
                    <span id="Scratchpad_title">
                        <span id="heading_text">Amazon Pay Scratchpad</span>
                        <span id="Scratchpad_header_help"><HelpHeader region={this.props.region} /></span><br/><br/>
                    </span>
                </KatBox>
            </div>
            </>
        );
    }
}

export default ScratchpadHeader;
